export default __webpack_public_path__ + "static/media/faceBotD.34720565.png";